import { Controller } from "@hotwired/stimulus";
import { clearError, showError } from "./client_side_validations_controller";

const YEAR_FORMAT = /^\d{4}$/;

// Connects to data-controller="member-course-form"
export default class extends Controller {
  static targets = ["course", "row"];

  courseChanged(event) {
    const parentId = event.target.value;
    if (!parentId) return;

    fetch(`/courses/${parentId}/leaf_children`, {
      headers: { Accept: "text/vnd.turbo-stream.html" },
    })
      .then((response) => response.text())
      .then((html) => {
        document.getElementById("course_children_frame").innerHTML = html;
      })
      .catch((err) => console.error(err));
  }

  rowTargetConnected(row) {
    if (row.dataset.validated) this.validateRow(row);
  }

  validate(event) {
    const rowsValid = this.rowTargets
      .map((row) => this.validateRow(row))
      .every(Boolean);
    if (this.validateSelection() && rowsValid) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    this.element.querySelector("[aria-invalid='true']")?.focus();
  }

  revalidate({ target }) {
    if (this.selectionValidated) this.validateSelection();

    const row = this.rowTargets.find((row) => row.contains(target));
    if (row?.dataset.validated) this.validateRow(row);
  }

  validateSelection() {
    this.selectionValidated = true;
    const valid = this.rowTargets.some(
      (row) => this.fields(row).checkbox.checked,
    );

    if (valid) clearError(this.courseTarget);
    else showError(this.courseTarget, "Select at least one course");
    return valid;
  }

  validateRow(row) {
    const { checkbox, date, year } = this.fields(row);
    if (!checkbox.checked) {
      [date, year].forEach(clearError);
      return true;
    }

    row.dataset.validated = "true";
    const errors = [
      [date, date.value ? null : "Date can't be blank"],
      [year, this.yearError(year.value)],
    ];
    errors.forEach(([field, message]) =>
      message
        ? showError(field, message, row.lastElementChild)
        : clearError(field),
    );
    return errors.every(([, message]) => !message);
  }

  yearError(value) {
    if (!value.trim()) return "Year can't be blank";
    if (!YEAR_FORMAT.test(value)) return "Year must be 4 digits";
  }

  fields(row) {
    return {
      checkbox: row.querySelector("input[type=checkbox]"),
      date: row.querySelector("input[name*='[date_attend]']"),
      year: row.querySelector("input[name*='[year_attend]']"),
    };
  }
}
